module.exports = __webpack_public_path__ + "static/media/Menu-11.0616de81.jpg";